import { Control, Controller } from 'react-hook-form';

import { useTranslate } from '@i18n';
import { Select, Stack, Text, u } from '@ui';

import { UserWelcomeWizardForm } from '../useUserWelcomeWizard';

type HandicapStepProps = {
    control: Control<UserWelcomeWizardForm>;
};

const handicapOptions = Array.from({ length: 65 }, (_, index) => {
    const value = index - 10;
    return {
        value: String(value),
        label: value < 0 ? `+${Math.abs(value)}` : String(value),
    };
});

export const HandicapStep = ({ control }: HandicapStepProps) => {
    const t = useTranslate();

    return (
        <Controller
            control={control}
            name="handicap"
            render={({ field }) => (
                <Stack gap={u(1)}>
                    <Select
                        options={handicapOptions}
                        selectedValue={String(field.value)}
                        onChange={(values) => field.onChange(Number(values[0]))}
                        label={t('user_welcome_wizard.handicap_input_label')}
                        placeholder={t('user_welcome_wizard.handicap_input_placeholder')}
                        width="100%"
                    />
                    <Text variant="pSmall" color="muted">
                        {t('user_welcome_wizard.handicap_disclaimer')}
                    </Text>
                </Stack>
            )}
        />
    );
};
